import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

// 省：region；市：city_code
export const pageSearch = {
  'region': {
    title: '省',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'city_code': {
    title: '市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'street_code': {
    title: '区',
    type: 'select',
    equation: cusname,
    dictionary: 'street'
  }
}

export default {
  'partner': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'name_last': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'adr_kind': {
    describe: true,
    title: '地址类型',
    type: 'select',
    equation: city,
    dictionary: 'A0099'
  },
  'c_o_name': {
    title: '联系人',
    type: 'input',
    equation: all
  },
  'building': {
    title: '身份证号',
    type: 'input',
    equation: all,
    width: 150
  },
  'telnr_long': {
    title: '电话',
    type: 'input',
    equation: all
  },
  'tel_number': {
    title: '手机',
    type: 'input',
    equation: all
  },
  'country': {
    title: '国家',
    type: 'input',
    equation: all
  },
  'bezei': {
    title: '省'
    // type: 'select',
    // equation: be,
    // dictionary: 'region'
  },
  'city_name': {
    title: '市'
    // type: 'select',
    // equation: city,
    // dictionary: 'city'
  },
  'street_name': {
    title: '区'
    // type: 'select',
    // equation: cusname,
    // dictionary: 'street'
  },
  'street': {
    title: '地址',
    type: 'input',
    equation: all,
    width: 250
  }
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/clientAddress.js